import { template } from '../view/template';
import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from '../component/IntegrityMonitorCustomRuleActionsFormWebComponent';
import { IntegrityMonitorCustomRuleActionsFormView } from '../view/IntegrityMonitorCustomRuleActionsFormView';
import { IntegrityMonitorCustomRulesAttribute } from '../../../../common/utils/types';
import { IntegrityMonitorCustomRuleActionItemWebComponent } from '../../imCustomRuleActionItem';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export class IntegrityMonitorCustomRuleActionsFormController extends BaseWebComponentController {
  public view!: IntegrityMonitorCustomRuleActionsFormView;
  public selectedCheckboxes: boolean[] = [];

  private subject: BehaviorSubject<boolean>;
  public valid$: Observable<boolean>;

  constructor(component: IntegrityMonitorCustomRuleActionsFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrityMonitorCustomRuleActionsFormView,
      viewTemplate: template,
    });

    this.subject = new BehaviorSubject<boolean>(false);
    this.valid$ = this.subject.pipe(distinctUntilChanged());
  }

  public setOptions(attributes: IntegrityMonitorCustomRulesAttribute[]) {
    attributes.forEach((attribute: IntegrityMonitorCustomRulesAttribute, index: number) => {
      this.selectedCheckboxes.push(false);
      const comp = new IntegrityMonitorCustomRuleActionItemWebComponent();
      this.view.dom.$actionsContainer.appendChild(comp);
      comp.injectDependencies(this.dependencies);
      comp
        .start()
        .catch(console.warn)
        .then(() => {
          comp.options = attribute;
          comp.id = attribute.value;
          const checkbox = comp.controller.view.dom.$checkboxFormField;
          const dropdown = comp.controller.view.dom.$dropdownFormField;

          checkbox.initialValue = false;
          dropdown.initialValue = 'no_action';

          const checkboxChangeCallback = event => {
            this.selectedCheckboxes[index] = event.detail.checked;
            this.subject.next(this.selectedCheckboxes.some(x => x));
          };
          checkbox.addEventListener('change', checkboxChangeCallback.bind(this));

          comp.refreshOptions('');

          this.view.formGroup.addFormChild([attribute.value, 'enabled'], checkbox);
          this.view.formGroup.addFormChild([attribute.value, 'action'], dropdown);
        });
    });
  }

  public refreshOptions(os: string) {
    const children = this.view.dom.$actionsContainer.children;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child instanceof IntegrityMonitorCustomRuleActionItemWebComponent) child.refreshOptions(os);
    }
  }
}
